import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import dashboardService from '../services/dashboard-service';
import {setMessage} from './message';

export const fetchDashboardData = createAsyncThunk(
  'dashboard/fetchDashboardData',
  async ({startDate, endDate,month,year,graph_month,graph_year}, thunkAPI) => {
    try {
      const response = await dashboardService.getDashboardData(
        startDate,
        endDate,
        month,
        year,
        graph_month,
        graph_year,
      );
  
      
      return response.data.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message);
    }
  },
);

const initialState = {
  data: [], // Data for current page
  list: [], // All fetched data (combined from multiple pages)
  loading: false,
  totalRecord: 0,
  totalPages: 0,
  currentPage: 1,
  status: 'idle',
  error: null,
  hasMore: true,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    resetDashboard: state => {
      return initialState;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchDashboardData.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;
        state.data = action.payload || {}; // Store the entire payload as is
        state.error = null;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
        state.data = {};
      });
  },
});

export const {resetDashboard} = dashboardSlice.actions;
export default dashboardSlice.reducer;
